import { PlusIcon, XIcon } from "@phosphor-icons/react";
import { useState } from "react";

type Props = {
  value: string[];
  placeholder: string;
  suggestions?: string[];
  onChange: (value: string[]) => void;
};

export const KeywordsField = ({ value, placeholder, suggestions = [], onChange }: Props) => {
  const [draft, setDraft] = useState("");

  const add = (raw: string) => {
    const keyword = raw.trim();
    if (!keyword || value.some((item) => item.toLocaleLowerCase() === keyword.toLocaleLowerCase()))
      return;
    onChange([...value, keyword]);
    setDraft("");
  };

  return (
    <div className="mt-1.5 rounded-xl border border-slate-200 bg-white p-2 focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-100">
      <div className="flex min-h-7 flex-wrap gap-1.5">
        {value.map((keyword) => (
          <span
            key={keyword}
            className="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2.5 py-1 text-[10px] font-semibold text-indigo-700"
          >
            {keyword}
            <button
              type="button"
              aria-label={`Retirer ${keyword}`}
              onClick={() => onChange(value.filter((item) => item !== keyword))}
              className="rounded-full hover:bg-indigo-100"
            >
              <XIcon size={11} weight="bold" />
            </button>
          </span>
        ))}
        <input
          value={draft}
          placeholder={value.length ? "Ajouter…" : placeholder}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === ",") {
              event.preventDefault();
              add(draft);
            }
            if (event.key === "Backspace" && !draft && value.length) onChange(value.slice(0, -1));
          }}
          onBlur={() => add(draft)}
          className="h-7 min-w-36 flex-1 bg-transparent px-1 text-xs font-medium text-[#071451] outline-none placeholder:text-slate-400"
        />
      </div>
      {suggestions.some((item) => !value.includes(item)) && (
        <div className="mt-2 flex flex-wrap gap-1 border-t border-slate-100 pt-2">
          {suggestions
            .filter((item) => !value.includes(item))
            .slice(0, 6)
            .map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => add(item)}
                className="inline-flex items-center gap-1 rounded-full border border-slate-200 px-2 py-1 text-[9px] font-medium text-slate-500 hover:border-indigo-300 hover:text-indigo-700"
              >
                <PlusIcon size={10} />
                {item}
              </button>
            ))}
        </div>
      )}
    </div>
  );
};
